module.exports={render:function (){
var _obj, _obj$1, _obj$2, _obj$3, _obj$4, _obj$5, _obj$6;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "data-vv-scope": _vm.fieldName
    }
  }, [_c('div', {
    class: ['form-group', ( _obj = {}, _obj['has-error'] = _vm.errors.first(_vm.fieldName + '-source-form-id', _vm.fieldName), _obj )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-source-form-id'
    }
  }, [_vm._v("Source form name*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.sourceFormId),
      expression: "field.sourceFormId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-form-id',
      "data-vv-name": _vm.fieldName + '-source-form-id'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "sourceFormId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateFormFields]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.forms), function(form) {
    return (form.id !== _vm.formId) ? _c('option', {
      domProps: {
        "value": form.id
      }
    }, [_vm._v(_vm._s(form.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSourceFormRangeSelectVisible),
      expression: "isSourceFormRangeSelectVisible"
    }],
    staticClass: "row",
    class: {
      'form-group': _vm.field.sourceFormData == 'daterange-field'
    }
  }, [_c('div', {
    class: {
      'col-lg-6': _vm.field.sourceFormData == 'daterange',
      'col-lg-12': _vm.field.sourceFormData != 'daterange'
    }
  }, [_c('div', {
    class: ['form-group', ( _obj$1 = {}, _obj$1['has-error'] = _vm.errors.first(_vm.fieldName + '-source-form-data', _vm.fieldName), _obj$1 )]
  }, [_c('label', [_vm._v("Source forms range*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.sourceFormData),
      expression: "field.sourceFormData"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-form-data',
      "data-vv-name": _vm.fieldName + '-source-form-data'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "sourceFormData", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 'all'
    }
  }, [_vm._v("All filled forms")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'last'
    }
  }, [_vm._v("Most recent entry")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'daterange'
    }
  }, [_vm._v("Completed At Date range")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'daterange-field'
    }
  }, [_vm._v("Field Date range")])])])]), _vm._v(" "), (_vm.field.sourceFormData == 'daterange-field') ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    class: ['form-group', ( _obj$2 = {}, _obj$2['has-error'] = _vm.errors.first(_vm.fieldName + '-daterange-field', _vm.fieldName), _obj$2 )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-daterange-field'
    }
  }, [_vm._v("Date field*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.dateRangeField),
      expression: "field.dateRangeField"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-daterange-field',
      "data-vv-name": _vm.fieldName + '-daterange-field'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "dateRangeField", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.formFields), function(value) {
    return (value.name.includes('date')) ? _c('option', {
      domProps: {
        "value": value.name
      }
    }, [_vm._v("[" + _vm._s(value.label) + "] " + _vm._s(value.description))]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (['daterange', 'daterange-field'].includes(_vm.field.sourceFormData)) ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    class: ['form-group', ( _obj$3 = {}, _obj$3['has-error'] = _vm.errors.first(_vm.fieldName + '-datepicker', _vm.fieldName), _obj$3 )]
  }, [_c('label', [_vm._v("Select date range*")]), _vm._v(" "), _c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "placeholder": "Select Date Range",
      "lang": "en",
      "range-separator": "-",
      "format": _vm.calendarFormat,
      "value-type": 'format',
      "range": true,
      "confirm": false,
      "prefix-class": "xmx",
      "data-vv-name": _vm.fieldName + '-datepicker'
    },
    model: {
      value: (_vm.field.sourceFormDataRange),
      callback: function($$v) {
        _vm.$set(_vm.field, "sourceFormDataRange", $$v)
      },
      expression: "field.sourceFormDataRange"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: ['form-group', ( _obj$4 = {}, _obj$4['has-error'] = _vm.errors.first(_vm.fieldName + '-source-field', _vm.fieldName), _obj$4 )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-source-field'
    }
  }, [_vm._v("Source field*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.sourceFieldName),
      expression: "field.sourceFieldName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-field',
      "data-vv-name": _vm.fieldName + '-source-field'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "sourceFieldName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.formFields), function(value) {
    return _c('option', {
      domProps: {
        "value": value.name
      }
    }, [_vm._v("[" + _vm._s(value.label) + "] " + _vm._s(value.description))])
  })], 2)]), _vm._v(" "), (_vm.availableOptions.length) ? _c('div', {
    class: ['form-group', ( _obj$5 = {}, _obj$5['has-error'] = _vm.errors.first(_vm.fieldName + '-source-field-value', _vm.fieldName), _obj$5 )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-source-field-value'
    }
  }, [_vm._v("Filter value*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.sourceFieldValue),
      expression: "field.sourceFieldValue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-field-value',
      "data-vv-name": _vm.fieldName + '-source-field-value'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "sourceFieldValue", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "__all"
    }
  }, [_vm._v("[All values]")]), _vm._v(" "), _vm._l((_vm.availableOptions), function(opt) {
    return _c('option', {
      domProps: {
        "value": opt.label
      }
    }, [_vm._v(_vm._s(opt.label))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.field.sourceFormData !== 'last') ? _c('div', {
    class: ['form-group', ( _obj$6 = {}, _obj$6['has-error'] = _vm.errors.first(_vm.fieldName + '-source-field-fn', _vm.fieldName), _obj$6 )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-source-field-fn'
    }
  }, [_vm._v("Source field function*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.sourceFieldFunction),
      expression: "field.sourceFieldFunction"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-field-fn',
      "data-vv-name": _vm.fieldName + '-source-field-fn'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "sourceFieldFunction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "count"
    }
  }, [_vm._v("Count")]), _vm._v(" "), (['number', 'currency'].includes(_vm.field.sourceFieldType)) ? _c('option', {
    attrs: {
      "value": "sum"
    }
  }, [_vm._v("Sum")]) : _vm._e(), _vm._v(" "), (['number', 'currency'].includes(_vm.field.sourceFieldType)) ? _c('option', {
    attrs: {
      "value": "avg"
    }
  }, [_vm._v("Average")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.availableOptions.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Available options")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table available-options-table"
  }, [_c('tr', _vm._l((_vm.availableOptions), function(opt) {
    return _c('td', [_c('span', [_vm._v(_vm._s(opt.label))])])
  }), 0)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-085de812","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/atoms/FormBuilderSharedField.vue
// module id = 1545
// module chunks = 1